﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import config from '../../../../common/config';
import language from '../../../../common/language';

import * as Entities_Empty from '../../../../lib/entities/empty';

import tpl_menu from './tpl/menu.html';

export default Marionette.LayoutView.extend({
    tagName:'div',
    className: 'container',
    initialize: function () {
        this.app = this.options.app;

        this.model = new Entities_Empty.Model();
        this.model.attributes.CultureName = language.getLanguageFromCodeCultureName(config.cultureName());

        this.modelCustom = this.options.modelCustom;

        var userChannel = Backbone.Radio.channel('app');

        var self = this;

        userChannel.on('Region_Menu:login', function () {
            /*return userManager.signinRedirect({
                extraQueryParams: {
                    identity_provider: 'Local',
                    hardcoded_identity_id: '1',
                },
            });*/

            self.menu_btnAuthClick();
        });

        userChannel.on('Region_Menu:setLoginName', function () {
            if (self.app.mgr.profile !== undefined) {
                self.ui.menu_btnAuth.css('display', 'none');
                self.ui.menu_btnAuthLogoff.show();
                self.ui.menu_btnAuthPortal.show();
                self.ui.menu_btnForgotPassword.css('display', 'none');
                self.ui.menu_li_price.css('display', 'none');
                self.ui.menu_loginName.show();

                var events4usUser_FirstName = localStorage.getItem('events4usUser_FirstName');
                var events4usUser_AttPerson = localStorage.getItem('events4usUser_AttPerson');
                var events4usUser_Organisation = localStorage.getItem('events4usUser_Organisation');

                var displayName = events4usUser_FirstName;

                switch (events4usUser_Organisation) {
                    case "0": displayName = events4usUser_FirstName; break;
                    case "1": displayName = events4usUser_AttPerson; break;
                    case "2": displayName = events4usUser_AttPerson; break;
                }

                if (displayName.length <= 0) {
                    self.ui.menu_loginName.html('');
                } else {
                    var userTag = ' ' + resources.X100278 + ' ' + displayName + '!';
                    self.ui.menu_loginName.html('<i class="fa fa-user"></i>' + ' ' + resources.X100278 + ' ' + displayName + '!');
                }
            } else {
                self.ui.menu_btnAuth.show();
                self.ui.menu_btnAuthLogoff.css('display', 'none');
                self.ui.menu_btnAuthPortal.css('display', 'none');
                self.ui.menu_btnForgotPassword.show();
                self.ui.menu_li_price.show();
                //$(self.ui.menu_li_loginName).html('');
                self.ui.menu_loginName.css('display', 'none');
            }
        });
    },
    getTemplate: function () {
        return tpl_menu({ model: this.model.toJSON() });
    },
    ui: {
        'menu_selectFlagstrip': '#menu_selectFlagstrip',
        'menu_loginName': '#menu_loginName',
        'menu_btnAuth': '#menu_btnAuth',
        'menu_btnAuthLogoff': '#menu_btnAuthLogoff',
        'menu_btnAuthPortal': '#menu_btnAuthPortal',
        'menu_li_price': '#menu_li_price',
        'menu_li_loginName': '#menu_li_loginName',
        'menu_btnForgotPassword': '#menu_btnForgotPassword'
    },
    events: {
        'click @ui.menu_btnAuth': 'menu_btnAuthClick',
        'click @ui.menu_btnAuthLogoff': 'menu_btnAuthLogoffClick',
        'click @ui.menu_btnAuthPortal': 'menu_btnAuthPortalClick',
        'click @ui.menu_btnForgotPassword': 'menu_btnForgotPasswordClick'
    },
    onRender: function () {
        
    },
    onAttach() {
        $('#menu_selectFlagstrip').flagStrap({
            countries: {
                "DK": "Denmark",
                "GB": "United Kingdom"
            },
            buttonSize: "btn-sm",
            buttonType: "btn-info",
            labelMargin: "10px",
            scrollable: false,
            scrollableHeight: "350px",
        });

        $('.dropdown-toggle').css('background-color', 'transparent');
        $('.dropdown-toggle').css('padding-top', '4px');
        $('.dropdown-toggle').css('color', 'rgb(248,201,196)');
        $('.dropdown-toggle').css('font-size', '14px');

        $('.dropdown-menu').css('margin-top', '0px');

        //$('.dropdown-menu').val(language.getLanguageFromCodeCultureName(config.cultureName()));

        //if (this.app.mgr.profile !== undefined) {
        //    this.ui.menu_btnAuth.css('display', 'none');
        //    this.ui.menu_btnAuthLogoff.show();
        //    this.ui.menu_btnAuthPortal.show();
        //    this.ui.menu_btnForgotPassword.css('display', 'none');
        //    this.ui.menu_li_price.css('display', 'none');
        //    this.ui.menu_loginName.show();
        //} else {
        //    this.ui.menu_btnAuth.show();
        //    this.ui.menu_btnAuthLogoff.css('display', 'none');
        //    this.ui.menu_btnAuthPortal.css('display', 'none');
        //    this.ui.menu_btnForgotPassword.show();
        //    this.ui.menu_li_price.show();
        //    this.ui.menu_loginName.css('display', 'none');
        //}
    },
    menu_btnAuthClick: function (event) {
        if (event) {
            event.preventDefault();
        }

        window.mgr.redirectForToken().then(function () {
            //alert('Success: ');
        }, function (err) {
            //alert('Error: ');
        });
    },
    menu_btnAuthLogoffClick: function (event) {
        event.preventDefault();

        mgr.redirectForLogout();
    },
    menu_btnForgotPasswordClick: function (event) {
        event.preventDefault();

        window.app.router.navigate("#forgotPassword");
        window.app.router.forgotPassword();
    }

}, Backbone.Radio.Requests);
